import { Check } from 'lucide-react'
import { FadeIn } from '@/components/templates/blocks/FadeIn.js'
import { Button, Container, Text } from '@/components/ui/index.js'
import styles from './PricingSection.module.css'

interface PricingSectionProps {
  onLogin: (provider: 'kakao' | 'naver') => void
}

const plans = [
  {
    name: 'Premium',
    price: '9,900원',
    priceSub: '/ 1회',
    highlighted: true,
    cta: '프리미엄 시작하기',
    features: [
      'AI 크레딧 10개',
      '전체 + 프리미엄 전용 템플릿',
      '청첩장 1개, 13개 섹션',
      'RSVP, 방명록',
      '워터마크 제거',
      '우선 생성',
    ],
  },
  {
    name: 'Free',
    price: '0원',
    priceSub: '',
    highlighted: false,
    cta: '무료로 시작하기',
    features: [
      'AI 크레딧 2개',
      '기본 6종 템플릿',
      '청첩장 1개, 13개 섹션',
      'RSVP, 방명록',
    ],
  },
]

export function PricingSection({ onLogin }: PricingSectionProps) {
  return (
    <section className={styles.section}>
      <Container size="lg">
        <FadeIn>
          <Text variant="heading-lg" align="center" className={styles.heading}>
            합리적인 가격
          </Text>
        </FadeIn>
        <div className={styles.grid}>
          {plans.map((plan) => (
            <FadeIn key={plan.name}>
              <div className={`${styles.card} ${plan.highlighted ? styles.highlighted : ''}`}>
                <Text variant="heading-sm">{plan.name}</Text>
                <div className={styles.priceRow}>
                  <Text variant="heading-lg" className={styles.price}>{plan.price}</Text>
                  {plan.priceSub && (
                    <Text variant="body-sm" color="secondary">{plan.priceSub}</Text>
                  )}
                </div>
                <ul className={styles.featureList}>
                  {plan.features.map((f) => (
                    <li key={f} className={styles.featureItem}>
                      <Check size={16} className={styles.checkIcon} />
                      <Text variant="body-md">{f}</Text>
                    </li>
                  ))}
                </ul>
                <Button
                  size="lg"
                  variant={plan.highlighted ? 'primary' : 'outline'}
                  className={styles.cta}
                  onClick={() => onLogin('kakao')}
                >
                  {plan.cta}
                </Button>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn>
          <Text variant="body-sm" color="secondary" align="center" className={styles.note}>
            AI 크레딧 추가 구매: 1개 1,000원 / 10개 8,000원
          </Text>
        </FadeIn>
      </Container>
    </section>
  )
}
